import { api } from 'service/api';
import { fieldMasterSetupViewApi } from 'service/apiVariables';

// get Request Param Master list View Api
export const getfieldMasterSetupListAct = (query) => {
  const { getfieldMasterSetupViewListApi } = fieldMasterSetupViewApi;
  getfieldMasterSetupViewListApi.query = query || {};
  return api({ ...getfieldMasterSetupViewListApi });
};

// Post Request Param mapping
export const postAddFieldMasterMappingAct = (payload) => {
  const { postAddFieldMasterMappingApi } = fieldMasterSetupViewApi;
  return api({ ...postAddFieldMasterMappingApi, body: payload });
};

// Post Logout
export const postLogoutAct = () => {
  const { postLogoutApi } = fieldMasterSetupViewApi;
  return api({ ...postLogoutApi });
};
